import { formatSnippetArgs } from "../../../../utils"
import { type Filter, filters } from "./types"

export function formatFilterSnippet(filter: Filter) {
  const args = filters.find((f) => f.type === filter.type)?.args

  if (!args) {
    throw new Error(`Filter type ${filter.type} not found.`)
  }

  return `filter.${filter.type}(${formatSnippetArgs(
    args.map((arg, index) =>
      filter.args[index] !== undefined ? filter.args[index] : Symbol(arg),
    ),
  )})`
}
